// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-item[data-v-2d7d2b5e]{display:flex;align-items:center;flex-direction:row;padding:10px 25px 10px 15px;font-size:1.4rem;background:white;transition:all 0.3s ease}.dropdown-item[data-v-2d7d2b5e]:hover{background:#f9f9f9}.dropdown-item[data-v-2d7d2b5e]:not(:last-child){border-bottom:1px solid #ECECEC}.dropdown-item *[data-v-2d7d2b5e]{display:flex}.dropdown-item *[data-v-2d7d2b5e]:not(:last-child){padding-right:8px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
